import { render, staticRenderFns } from "./stallholders.vue?vue&type=template&id=2cdd1436&scoped=true"
import script from "./stallholders.vue?vue&type=script&lang=js"
export * from "./stallholders.vue?vue&type=script&lang=js"
import style0 from "./stallholders.vue?vue&type=style&index=0&id=2cdd1436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd1436",
  null
  
)

export default component.exports